import { module } from 'stereomodularjs'

import Swiper from 'swiper';
import { Navigation, Pagination, Scrollbar, A11y, EffectCreative, Autoplay } from 'swiper/modules';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Scrollbar, A11y, EffectCreative, Autoplay]);

export default class extends module {
    constructor(m) {
        super(m)
    }

    init() {
        this.params = {
            // Optional parameters
            direction: 'horizontal',
            loop: true,
            slidesPerView: 'auto',
            grabCursor: true,
            touchEventsTarget: 'container',

            // If we need pagination
            pagination: {
                el: this.el.querySelector('.swiper-pagination'),
                clickable: true,
            },

            // Navigation arrows
            navigation: {
                nextEl: this.el.querySelector('.swiper-button-next'),
                prevEl: this.el.querySelector('.swiper-button-prev'),
            },

            // And if we need scrollbar
            scrollbar: {
                el: this.el.querySelector('.swiper-scrollbar'),
                draggable: true,
            },

            // a11y
            a11y: {
                prevSlideMessage: 'Previous slide',
                nextSlideMessage: 'Next slide',
                paginationBulletMessage: 'Go to slide {{index}}',
                firstSlideMessage: 'This is the first slide',
                lastSlideMessage: 'This is the last slide',
            },
        }

        this.typeSlider = this.el.dataset.type

        if (this.typeSlider == 'card') {
            this.params.navigation = {
                nextEl: this.el.querySelector('.swiper-button-next'),
                prevEl: this.el.querySelector('.swiper-button-prev'),
            }
            this.params.effect = 'creative'
            this.params.creativeEffect = {
                prev: {
                    perspective: true,
                    translate: ['-20%', 0, -400],
                },
                next: {
                    perspective: true,
                    translate: ['102%', 0, 0],
                },
                limitProgress: 2,
            }
        }else if (this.typeSlider == 'autoplay') {
            this.params.autoplay = {
                delay: 5000,
                disableOnInteraction: false,
            }

        }else if (this.typeSlider == 'mobile') {
            this.params.slidesPerView = 1.1
            this.params.spaceBetween = 16
            this.params.allowTouchMove = true
            this.params.grabCursor = true
            this.params.loop = false
            this.params.breakpoints = {
                540: {
                    slidesPerView: 1.35,
                    allowTouchMove: true,
                    grabCursor: true,
                },
                768: {
                    allowTouchMove: false,
                    grabCursor: false,
                },
            }
            addEventListener('resize', () => {
                if (window.innerWidth > 768) {
                    this.slider.slideTo(0, 0, false)
                    this.el.querySelector('.swiper-wrapper').removeAttribute('style')
                }
            })
        }


        this.slider = new Swiper(this.el, this.params)

    }

    destroy() {
        this.slider.destroy();
    }
}